export enum PageRoutes {
  HomePage = "/",
  Profile = "/profile",
  Search = "/search",
  Rank = "/rank",
  Esports = "/esports",
  Level = "/profile/level",
  EditProfile = "/profile/edit",
  Friends = "/friends",
  Shop = "/shop",
  BundleDetail = "/shop/bundle",
  Settings = "/settings",
  Languages = "/settings/languages",
  Subscription = "/settings/subscription",
  Faq = "/support/faq",
  TermsAndConditions = "/support/term",
  PrivacyPolicy = "/support/privacy",
  CookiePolicy = "/support/cookie",
  Apps = "/apps",
  Videos = "/videos",
  VideosVodacom = "/videos-vodacom",
  SearchVideo = "/search-video",
  Notifications = "/notifications",
  Onboarding = "/onboarding",
  SetProfile = "/onboarding/set-profile",
  Guest = "/guest",
  GamePlay = "/play",
  Feed = "/feed",
}
